interface StorageLoc {
    storage_location: string;
}
// TODO should this really be in refetch?  Is there a way/reason to combine with getUserFromStorage in user.service?
export function getTokenFromStorage<T>(key: string): T & StorageLoc | undefined {
    let item: T & StorageLoc;
    let isLocal: boolean = true;
    let storeItem = localStorage.getItem(key);
    if (!storeItem) {
        storeItem = sessionStorage.getItem(key);
        isLocal = !storeItem;
    }

    if (!!storeItem) {
        item = JSON.parse(storeItem);
        (item as StorageLoc).storage_location = isLocal ? "ls" : "ss";
        return item || undefined;
    }

    return undefined;
}

export function storeTokenInStorage(key: string, token: any) {
    const data = JSON.stringify(token);
    localStorage.setItem(key, data);
}
